// Numéro de registre national belge : 11 chiffres, les 2 derniers étant une clé de contrôle (modulo 97).

export const normalizeNationalRegister = (value: string): string => value.replace(/\D/g, '')

/**
 * Clé de contrôle : 97 − (9 premiers chiffres mod 97). Pour les personnes nées à partir de 2000,
 * on préfixe les 9 premiers chiffres d'un « 2 » avant le calcul ; les deux variantes sont donc acceptées.
 */
export const isValidNationalRegister = (value: string): boolean => {
  const digits = normalizeNationalRegister(value)
  if (!/^\d{11}$/.test(digits)) return false
  const base = Number(digits.slice(0, 9))
  const check = Number(digits.slice(9))
  return 97 - (base % 97) === check || 97 - ((2_000_000_000 + base) % 97) === check
}
